import React from "react";
import styles from "./Implement.module.scss";
import Select from "react-select"
import idea from "./idea.svg";
import disk_narrow from "./disk_narrow.png";
import power_bidder from "./power_bidder.png"
import rotary_tiller from "./rotary_tiller.png"
import sieve from "./sieve.png"
class Implement extends React.Component {
    state = {
        name:null,
        src:null,
        selectedIndex:-1
    }
    render() {
        const disable = this.state.name && this.state.src;
        const curvedStyle = {
            control: (base, state) => ({
                ...base,
                borderRadius: "25px",
                borderColor: "#ebedf0",
                width: "130px",
                fontSize:"12px"
            })

        }
        const finalcurvedStyle = {
            control: (base, state) => ({
                ...base,
                borderRadius: "25px",
                borderColor: "#ebedf0",
                width: "95px",
                fontSize:"12px"
            })

        }
        const directions = [
            { value: "Fruit & Tree Nuts", label: "Fruit & Tree Nuts" },
        ]
        const soil = [
            { value: "Soil Preparation", label: "Soil Preparation" },
        ]
        const task = [
            { value: "Tilling", label: "Tilling" },
        ]
        const implementsinfo = [
            { name: "Disk Narrow", src: disk_narrow },
            { name: "Rotary Tiller", src: rotary_tiller },
            { name: "Power Bedder", src: power_bidder },
            { name: "Sieve", src: sieve }
        ]
        const toRender = implementsinfo.map((e,i) => {
            return (
                <div  onClick={
                    ()=>{
                       this.setState({
                           name:e.name,
                           src:e.src,
                           selectedIndex:i
                       })
                    }
                } role="button" style={{
                    border: "1px solid #EBEDF0",
                    borderRadius: "15px",

                }} id="highlight" className={`d-flex flex-column  p-3 ${styles.tracktor__hover} ${this.state.selectedIndex === i?styles.tracktor__border:null} `}>
                    <div id="outter" className="d-flex justify-content-between imple_info">
                        <p id="inner" style={{
                            fontWeight: "500",
                            fontSize: "18px",
                            color: this.state.selectedIndex === i?"#3E7AFF":"#081C48"
                        }}>{e.name}</p>
                        <div className="implem_info">
                        <img src={idea} alt="idea"></img>
                        <div className="implementinfo_tootip">
                            <div className="d-flex justify-content-between">
                                <p className="text-muted" style={{
                                    fontWeight: "400",
                                    fontSize: "12px",
                                    flexBasis: "50%",
                                    paddingRight: "5px"
                                }}>manufactured <span style={{
                                    float: "right"
                                }}>-</span></p>
                                <p style={{
                                    fontWeight: "500",
                                    fontSize: "12px",
                                    color: "#081C48",
                                    flexBasis: "50%"
                                }}>manufactured</p>
                            </div>
                            <div className="d-flex justify-content-between">
                                <p className="text-muted" style={{
                                    fontWeight: "400",
                                    fontSize: "12px",
                                    flexBasis: "50%",
                                    paddingRight: "5px"
                                }}>ownership <span style={{
                                    float: "right"
                                }}>-</span></p>
                                <p style={{
                                    fontWeight: "500",
                                    fontSize: "12px",
                                    color: "#081C48",
                                    flexBasis: "50%"
                                }}>ownership</p>
                            </div>
                            <div className="d-flex justify-content-between">
                                <p className="text-muted" style={{
                                    fontWeight: "400",
                                    fontSize: "12px",
                                    flexBasis: "50%",
                                    paddingRight: "5px"
                                }}>type of connection <span style={{
                                    float: "right"
                                }}>-</span></p>
                                <p style={{
                                    fontWeight: "500",
                                    fontSize: "12px",
                                    color: "#081C48",
                                    flexBasis: "50%"
                                }}>type of connection</p>
                            </div>
                            <div className="d-flex justify-content-between">
                                <p className="text-muted" style={{
                                    fontWeight: "400",
                                    fontSize: "12px",
                                    flexBasis: "50%",
                                    paddingRight: "5px"
                                }}>min/max <span style={{
                                    float: "right"
                                }}>-</span></p>
                                <p style={{
                                    fontWeight: "500",
                                    fontSize: "12px",
                                    color: "#081C48",
                                    flexBasis: "50%"
                                }}>[1/2 M] turn radius</p>
                            </div>
                            <div className="d-flex justify-content-between">
                                <p className="text-muted" style={{
                                    fontWeight: "400",
                                    fontSize: "12px",
                                    flexBasis: "50%",
                                    paddingRight: "5px"
                                }}>max speed <span style={{
                                    float: "right"
                                }}>-</span></p>
                                <p style={{
                                    fontWeight: "500",
                                    fontSize: "12px",
                                    color: "#081C48",
                                    flexBasis: "50%"
                                }}>max speed</p>
                            </div>
                            <div className="d-flex justify-content-between">
                                <p className="text-muted" style={{
                                    fontWeight: "400",
                                    fontSize: "12px",
                                    flexBasis: "50%",
                                    paddingRight: "5px"
                                }}>dimensions <span style={{
                                    float: "right"
                                }}>-</span></p>
                                <p style={{
                                    fontWeight: "500",
                                    fontSize: "12px",
                                    color: "#081C48",
                                    flexBasis: "50%"
                                }}>dimensions</p>
                            </div>
                        </div>
                        </div>
                        
                    </div>
                    <img src={e.src} width="100%" alt="implement"></img>
                </div>
            )
        })
        return <div className={styles.absolute_modal}>
            <div style={{
                cursor: "pointer",
                fontSize: "15px"
            }} onClick={() => {
                this.props.toggleImplement()
            }} className="d-flex text-muted tractkor-back-btn">
                <p><i class="fa fa-chevron-left"></i> </p>
                <p className={styles.back_button_text}>Back</p>
            </div>
            <div className="d-flex align-items-center justify-content-between  p-3" style={{
                        width:"calc(100% - 100px)",
                        maxWidth:"100%",
                        marginLeft:"auto",
                        marginRight:"auto",
                        marginTop:"20px"
                    }}>
                <h4>Implement<span style={{
                    color: "#CED2DA"
                }} className="ml-1">4</span>
                </h4>
                <div className="d-flex">
                    <div className="d-flex align-items-center">
                        <small style={{
                            marginRight:"9px"
                        }} className="text-muted">Crop</small>
                        <Select className="ml-1" components={{
                            IndicatorSeparator: () => null
                        }} styles={curvedStyle} options={directions} ></Select>

                    </div>
                </div>
                <div className="d-flex">
                    <div className="d-flex align-items-center">
                        <small style={{
                            marginRight:"9px"
                        }}  className="text-muted">Work Type</small>
                        <Select className="ml-1" components={{
                            IndicatorSeparator: () => null
                        }} styles={curvedStyle} options={soil} ></Select>

                    </div>
                </div>
                <div className="d-flex">
                    <div className="d-flex align-items-center">
                        <small style={{
                            marginRight:"9px"
                        }}  className="text-muted">Work Type</small>
                        <Select className="ml-1" components={{
                            IndicatorSeparator: () => null
                        }} styles={finalcurvedStyle} options={task} ></Select>

                    </div>
                </div>
            </div>
            <div className={styles.grid + " p-3"}>
              {toRender}

            </div>
            <div style={{
                    backgroundColor:"rgba(255,255,255,1)",
                    position:"fixed",
                    bottom:"0px",
                    width:"100%",
                    marginLeft:"-32px",
                    backdropFilter:"blur(25px)",
                    zIndex:"9999"
                }}>
                    <button onClick={()=>{
                        if(this.state.name && this.state.src){
                            this.props.selectImplement(this.state.name,this.state.src)
                        }
                    }} style={{
                        width:"139px",
                        marginTop:"20px",
                        marginBottom:"20px",
                        marginRight:"20px",
                        height:"40px",
                        border:"none",
                        backgroundColor:disable?"#3E7AFF":"#EBEDF0",
                        borderRadius:"45px",
                        color:"#FFFFFF",
                        fontSize:"16px",
                        float:"right"
                    }}>
                        Submit
                    </button> 
                </div>
        </div>
    }
}
export default Implement